module.exports = __webpack_public_path__ + "static/biplan-76d2cef7e6b1754d604f8c9630f13156.svg";